import { render, staticRenderFns } from "./TranslationRequests.vue?vue&type=template&id=78e3d6f1&scoped=true"
import script from "./TranslationRequests.vue?vue&type=script&lang=js"
export * from "./TranslationRequests.vue?vue&type=script&lang=js"
import style0 from "./TranslationRequests.vue?vue&type=style&index=0&id=78e3d6f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e3d6f1",
  null
  
)

export default component.exports